import Swal from 'sweetalert2'

export default {
    actions: {
      NOTIF_SUCCESS:(_, payload) => {
        return new Promise(() => {
          Swal.fire({
            title: payload.poruka,
            icon: 'success',
            toast: true,
            position: payload.position,
            showConfirmButton: false,
            timer: payload.timer,
            timerProgressBar: true,
            width: payload.width,
            customClass: {
                popup: 'my-toast-popup'
            },
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
         }).then(function()
         {
            if(payload.action=="reload")
            {
              location.reload();
            }
            else
            {
              if(payload.action=="noreload")
              {
                //nothing to do
              }
              else
              {
                window.location.href= payload.action;
              }
            }
         })
        }) 
      },

      NOTIF_SUCCESSwithoutACTION:(_, payload) => {
        return new Promise(() => {
          Swal.fire({
            title: payload.poruka,
            icon: 'success',
            toast: true,
            position: payload.position,
            showConfirmButton: false,
            timer: payload.timer,
            timerProgressBar: true,
            width: payload.width,
            customClass: {
                popup: 'my-toast-popup'
            },
            didOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })
        }) 
      },

      NOTIF_WARNING:(_, payload) => {
      return new Promise(() => {
        Swal.fire({
          title: payload.poruka,
          icon: payload.icon,
          toast: true,
          position: payload.position,
          showConfirmButton: false,
          timer: payload.timer,
          timerProgressBar: true,
          width: payload.width,
          customClass: {
                popup: 'my-toast-popup'
            },
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })
      }) 
    },

    NOTIF_MESSAGE:(_, payload) => {
      return new Promise(() => {
        Swal.fire({
          title: payload.poruka,
          icon: payload.icon,
          toast: true,
          position: payload.position,
          showConfirmButton: false, // da se prikaže dugme
          confirmButtonText: 'OK', // tekst dugmeta
          showCloseButton: true,
          width: payload.width,
          customClass: {
                popup: 'my-toast-popup',
                closeButton: 'my-ok-button'
            },
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        })
      }).then(function()
         {
            if(payload.action=="reload")
            {
              location.reload();
            }
            else
            {
              if(payload.action=="noreload")
              {
                //nothing to do
              }
              else
              {
                window.location.href= payload.action;
              }
            }
         })
    },

    NOTIF_LOGOUT:(_, payload) => {
      return new Promise(() => {
        Swal.fire({
          title: payload.poruka,
          icon: 'warning',
          toast: true,
          position: payload.position,
          showConfirmButton: false,
          timer: payload.timer,
          timerProgressBar: true,
          width: payload.width,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
          }
        }).then(function()
        {
          localStorage.clear();
          window.location.href = "/";
        })
       }) 
    },
   
}
}
